import en from './en.json';

export class I18n {
  static get(key: string, dictionary?: {[key: string]: string}): string {
    const lang = this.getLang();
    let translation = lang[key] || key;
    if (dictionary) {
      Object.keys(dictionary).forEach((dictionaryKey) => {
        translation = translation.replaceAll(`{{${dictionaryKey}}}`, dictionary[dictionaryKey]);
      });
    }
    return translation;
  }

  private static getLang(): { [key: string]: string } {
    return en;
  }
}
